module.exports = __webpack_public_path__ + "static/media/ringtone.fc57774c.mp3";